import React, { useState, } from 'react';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { Row, Col, Card, CardBody, CardImg, Badge, Button } from 'reactstrap';
import { Calendar, Check, Copy, Download, Edit, Eye, Trash } from 'react-feather';
import PageView from './PageView';
import { setPages } from '../../../ReduxToolkit/Reducers/PageSlice';
import { toast } from 'react-toastify';
import { deleteReportAction, generateQRCodeAPI } from '../../../Api/report';
import { Link, useNavigate } from 'react-router-dom';
import { Btn, H4, H5, H6, P } from '../../../AbstractElements';

const GridPage = () => {
  const pages = useAppSelector((state) => state.pages.pages);
  const dispatch = useAppDispatch()
  const user = useAppSelector(state => state.user)
  const navigate = useNavigate()
  const downloadQRCode = async (pageId: string) => {
    try {
      const blob = await generateQRCodeAPI(pageId);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `QRCode_${pageId}.png`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      link.parentNode?.removeChild(link);
      toast.success('QR Code downloaded successfully!');
    } catch (error) {
      console.error('Failed to download QR Code:', error);
      toast.error('Failed to download QR Code. Please try again later.');
    }
  };

  const handleDelete = async (id: string) => {
    const response = await deleteReportAction(id)
    if (response?.data?.status === "success") {
      dispatch(setPages(pages.filter(page => id !== page.id)))
      toast.success('Delete page successful')
    }

  }
  return (
    <Row>
      {pages.map((page: any) => (
        <Col key={page.id} lg="6" xl="4" xxl="3" className="mb-4 page-card">
          <Card className='overflow-hidden border shadow-none'>
            <PageView elements={page.elements} />
            <CardBody>
              <H4 className="mb-3">{page.name || "Unnamed"}</H4>
              <div className="page-info d-flex justify-content-between mb-3">
                <div className={`upcoming-box d-flex align-items-center`}>
                  <div className={`upcoming-icon bg-light-secondary me-2 d-flex p-2 rounded-circle `}>
                    <Eye style={{ color: "#3632a3" }} width={18} height={18} />
                  </div>
                  <div>
                    <span className="text-gray">Page Views</span>
                    <H6>{`${page.views} times`}</H6>
                  </div>
                </div>
                <div className={`upcoming-box d-flex align-items-center`}>
                  <div className={`upcoming-icon bg-light-danger me-2 d-flex p-2 rounded-circle `}>
                    <Calendar className="text-danger" width={18} height={18} />
                  </div>
                  <div>
                    <span className="text-gray">Created At</span>
                    <H6>{new Date(page.created_at).toLocaleDateString()}</H6>
                  </div>
                </div>
              </div>
              <div className="page-action d-flex justify-content-between py-2">
                <div className="w-100">
                  <Button
                    color="secondary"
                    className="d-flex align-items-center px-2 py-1"
                    style={{ gap: '4px' }}
                    onClick={() => downloadQRCode(page.id)}
                  >
                    <Download style={{ width: 18 }} />
                    QR Code
                  </Button>
                </div>
                <div className="d-flex w-100 justify-content-end" style={{ gap: 4 }}>
                  <Button
                    color='primary'
                    className="d-flex align-items-center px-2 py-1"
                    type="button"
                    onClick={() => navigate(`/page/edit/${page.id}?from=/page/list`)}
                    style={{ gap: '4px' }}
                  >
                    <Edit style={{ width: 18 }} /> Edit
                  </Button>
                  <Button
                    color="danger"
                    className="d-flex align-items-center px-2 py-1"
                    style={{ gap: '4px' }}
                    type="button"
                    onClick={() => handleDelete(page.id)}
                  >
                    <Trash style={{ width: 18 }} /> Remove
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default GridPage;
